// Resize and compress an image file to a data URL.
// Returns a base64 JPEG data URL no wider than maxWidth pixels.
export function fileToCompressedDataURL(file, maxWidth = 1000, quality = 0.85) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      reject(new Error("O ficheiro selecionado não é uma imagem."));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Erro ao ler o ficheiro."));
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => reject(new Error("Não foi possível abrir a imagem."));
      img.onload = () => {
        const ratio = Math.min(1, maxWidth / img.width);
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        // Use JPEG for smaller size; preserve PNG only if has alpha & small
        const dataUrl = canvas.toDataURL("image/jpeg", quality);
        resolve(dataUrl);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
